import "./styles.scss"; 

import * as Material from "@mui/material";

export default function EditionModeButton({ editingEnabled, onToggle }) {
    return (
      <div className={`admin-edit-control ${editingEnabled ? 'editing-enabled' : ''}`}>
        <Material.FormControlLabel
          control={
            <Material.Switch
              checked={editingEnabled}
              onChange={(e) => onToggle(e.target.checked)}
              name="editingEnabled"
              color="primary"
              size="small"
            />
          }
          label={<span style={{ marginLeft: '-6px' }}>
            {editingEnabled ? 'Edições habilitadas' : 'Ativar edições'}
          </span>}
        />
      </div>
    );
  }